import { FC, memo, useMemo } from 'react'
import styled from 'styled-components'
import { Text } from '@ucheba/ui/components/Text/desktop'
import { Spacing } from '@ucheba/ui/components/Spacing/desktop'
import Link from 'next/link'
import { IProgramIdPageAboutInstitution } from '../types'

const Logo = styled.source`
  max-width: 64px;
  max-height: 80px;
`

const Img = styled.img`
  max-width: 64px;
  max-height: 80px;
`

const ProgramIdPageAboutInstitution: FC<IProgramIdPageAboutInstitution> = (props) => {
  const { institution, faculty } = props

  const alt = useMemo(() => {
    let text = ''

    if (institution?.abbreviation) {
      text += `${institution.abbreviation}, `
    }

    if (institution?.name) {
      text += institution.name
    }

    return text
  }, [institution])

  if (!institution && !faculty) return null

  const { logo } = institution || faculty || {}

  return (
    <>
      <Link href={`/uz/${faculty?.id || institution?.id}`}>
        <picture>
          <Logo srcSet={logo?.webp} type='image/webp' alt={alt} />

          <Img src={logo?.fallbackUrl} alt={alt} />
        </picture>
      </Link>

      <Spacing spacing='small' />

      <Link href={`/uz/${faculty?.id || institution?.id}`}>
        <Text fontSize='h4' lineHeight='h4' fontWeight='bold'>
          {faculty?.abbreviation || institution?.abbreviation}
        </Text>
      </Link>
    </>
  )
}

export default memo(ProgramIdPageAboutInstitution)
